<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="土地ID">
                <a-input v-model="queryParam.landId" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="操作类型">
                <a-select v-model="queryParam.operationType" allowClear>
                  <a-select-option :value="1">浇水</a-select-option>
                  <a-select-option :value="2">施肥</a-select-option>
                  <a-select-option :value="3">除草</a-select-option>
                  <a-select-option :value="4">捉虫</a-select-option>
                  <a-select-option :value="5">修剪</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="处理状态">
                <a-select v-model="queryParam.handleStatus" allowClear>
                  <a-select-option :value="0">待处理</a-select-option>
                  <a-select-option :value="1">已处理</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false" :bordered="tableBordered">
        <span slot="operationType" slot-scope="text, record">{{ getOperationName(record.operationType) }}</span>
        <span slot="handleStatus" slot-scope="text, record">
          <a-badge :status="record.handleStatus === 1 ? 'success' : 'default'" :text="record.handleStatus === 1 ? '已处理' : '待处理'" />
        </span>
        <span slot="remarkImages" slot-scope="text, record">
          <div v-if="record.remarkImages" class="remark-img-list">
            <a v-for="(img, idx) in record.remarkImages.split(',')" :key="idx" @click="previewImage(img)">
              <img :src="img" class="remark-img" />
            </a>
          </div>
          <span v-else>-</span>
        </span>
        <span slot="createTime" slot-scope="text, record">{{ parseTime(record.createTime) }}</span>
        <span slot="operation" slot-scope="text, record">
          <a :disabled="record.handleStatus === 1" @click="handleRecord(record)">处理</a>
        </span>
      </a-table>
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum" :total="total" :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`" @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="预览" style="width: 100%" :src="previewImageUrl" />
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageOperationRecord, handleOperationRecord } from '@/api/cloudplant/operationRecord'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'LandOperationRecord',
  mixins: [tableMixin],
  data() {
    return {
      list: [], loading: false, pageSizeOptions: ['10', '20', '50', '100'], total: 0,
      previewVisible: false,
      previewImageUrl: '',
      queryParam: { landId: undefined, operationType: undefined, handleStatus: undefined, pageNum: 1, pageSize: 10 },
      columns: [
        { title: '土地ID', dataIndex: 'landId', align: 'center' },
        { title: '用户昵称', dataIndex: 'userNickName', align: 'center' },
        { title: '操作类型', dataIndex: 'operationType', scopedSlots: { customRender: 'operationType' }, align: 'center' },
        // { title: '操作次数', dataIndex: 'operationCount', align: 'center' },
        { title: '用户备注', dataIndex: 'remarkText', align: 'center', ellipsis: true },
        { title: '用户备注图片', dataIndex: 'remarkImages', scopedSlots: { customRender: 'remarkImages' }, align: 'center' },
        { title: '处理状态', dataIndex: 'handleStatus', scopedSlots: { customRender: 'handleStatus' }, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center', width: 160 },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: 100 }
      ]
    }
  },
  created() { this.getList() },
  methods: {
    getList() { this.loading = true; pageOperationRecord(this.queryParam).then(response => { this.list = response.data.records; this.total = response.data.total; this.loading = false }) },
    getOperationName(type) { const names = { 1: '浇水', 2: '施肥', 3: '除草', 4: '捉虫', 5: '修剪' }; return names[type] || '' },
    handleQuery() { this.queryParam.pageNum = 1; this.getList() },
    resetQuery() { this.queryParam = { landId: undefined, operationType: undefined, handleStatus: undefined, pageNum: 1, pageSize: 10 }; this.handleQuery() },
    onShowSizeChange(current, pageSize) { this.queryParam.pageSize = pageSize; this.getList() },
    changeSize(current, pageSize) { this.queryParam.pageNum = current; this.queryParam.pageSize = pageSize; this.getList() },
    handleRecord(record) {
      const that = this
      this.$confirm({
        title: '确认处理',
        content: '确定将该记录标记为已处理吗？',
        onOk() {
          handleOperationRecord({ id: record.id }).then(() => {
            that.$message.success('处理成功')
            that.getList()
          })
        }
      })
    },
    previewImage(url) {
      this.previewImageUrl = url
      this.previewVisible = true
    }
  }
}
</script>

<style scoped>
.remark-img-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
}
.remark-img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}
</style>
